module.exports = __webpack_public_path__ + "img/index_bg.32f5008b.png";